var React = require('react');

function LeftQuote (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon / Quote"},React.createElement("path",{"id":"Icon / Quote_2","d":"M0 30V21.8563C0 19.3413 0.468584 16.7465 1.40575 14.0719C2.38552 11.3573 3.72737 8.78244 5.43131 6.34731C7.17785 3.87226 9.15868 1.75649 11.3738 0L19.0415 4.49102C17.3376 7.00599 15.9318 9.66068 14.8243 12.4551C13.7593 15.2096 13.2268 18.3234 13.2268 21.7964V30H0ZM20.9585 30V21.8563C20.9585 19.3413 21.427 16.7465 22.3642 14.0719C23.344 11.3573 24.6858 8.78244 26.3898 6.34731C28.1363 3.87226 30.1171 1.75649 32.3323 0L40 4.49102C38.2961 7.00599 36.8903 9.66068 35.7827 12.4551C34.7178 15.2096 34.1853 18.3234 34.1853 21.7964V30H20.9585Z","fill":"#527A66"})));
}

LeftQuote.defaultProps = {"width":"40","height":"30","viewBox":"0 0 40 30","fill":"none"};

module.exports = LeftQuote;

LeftQuote.default = LeftQuote;
